@if (props.prepend || props.append || props.appendClick) {
  <div class="input-group mb-3">
    @if (props.prepend) {
      <span class="input-group-text">{{ props.prepend }}</span>
    }
    <ng-template [ngTemplateOutlet]="input"></ng-template>
    @if (props.append) {
      <span class="input-group-text">{{ props.append }}</span>
    }
    @if (props.appendClick) {
      <button class="btn btn-outline-secondary" type="button" (click)="onAppendClick()">
        <i [class]="props.appendClickIcon"></i>
      </button>
    }
  </div>
} @else {
  @if (props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [value]="props.template"
      (click)="onClick($event)"
    />
  } @else {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [class.text-end]="props.textRight"
      (keyup.enter)="keyUpEnter($event)"
      (keyup.backspace)="keyUpBackspace($event)"
      (focus)="onFocus()"
      (click)="onClick($event)"
    />
  }
}

<ng-template #input>
  @if (props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [value]="props.template"
      (click)="onClick($event)"
    />
  }
  @if (!props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [class.text-end]="props.textRight"
      (keyup.enter)="keyUpEnter($event)"
      (keyup.backspace)="keyUpBackspace($event)"
      (focus)="onFocus()"
      (click)="onClick($event)"
    />
  }
</ng-template>
